module.exports = __webpack_public_path__ + "img/icon-jiesuo.d77ddd2c.svg";